export default "__VITE_ASSET__Uj8cccge__"